import { types } from "mobx-state-tree";

const optionalAndMaybeNull = type => types.optional(types.maybeNull(type));

export default optionalAndMaybeNull;
